export class SlotCheat {
  command: string;
  customConfig: string;
  reelsPositions: number[][] | null;

  toJson(): Record<string, unknown> {
    return {
      command: this.command,
      customConfig: this.customConfig,
      reelsPositions: this.reelsPositions,
    };
  }
}
